var Coupon = {
    init: function () {
        let form = $('#js-form-giftcode');

        if (form.length > 0) {

            form.on('submit', function (e) {
                e.preventDefault();

                let thisForm = $(this);
                let responseBlock = thisForm.find('.help-block');
                let input = thisForm.find('[name="gift-code"]');
                let coupon = input.val();

                $.ajax({
                    type: 'POST',
                    url: themosis.ajaxurl,
                    data: {
                        action: 'wc_add_coupon',
                        couponcode: coupon
                    },
                    beforeSend: function () {
                        responseBlock.remove();
                    },
                    success: function (data) {
                        data = JSON.parse(data);
                        if (data.code) {

                            let responseClass = '';

                            if (data.code == 200) {
                                responseClass = '-success';
                            } else {
                                responseClass = '-error';
                            }

                            let html = '<div class="help-block"><span class="msg ' + responseClass + '">' + data.message + '</span></div>';

                            thisForm.prepend(html);
                        }
                    }
                });
            });
        }

        // Remove coupon block on checkout by clicking on button
        $('.woocommerce-remove-coupon').on('click', function () {
            $(this).parents('.coupon-wrapper').remove();
        });
    }
}

module.exports = Coupon;
